import React, { useState } from "react";
import "./styles.css";

const Footer = () => {
  const redirectUrl = window.redirectUrl;
  const termsConditionsUrl = `${redirectUrl}pages/terminos-y-condiciones`;
  return (
    <footer>
      <div>
        <p>¿Necesitas ayuda?</p>
        <a
          href="https://wa.me/573118898116"
          target="_blank"
          rel="noopener noreferrer"
          className="talkWhatsapp"
        >
          +57 311 899 9300
        </a>
      </div>
      <a href={termsConditionsUrl} className="conditions">
        Términos & Condiciones
      </a>
    </footer>
  );
};

export default Footer;
